// Client V1 imports
const airbrake = require('client/lib/airbrake')
const { send: ajax, FriendlyRequestError } = require('client/lib/request')
const uploader = require('client/lib/uploader')
// Client V2 common imports
const clientV1Bridge = require('client-v2/common/client-v1-bridge')
// Container imports
const toastActions = require('../toasts/actions')

const urlsByImageFieldName = {
  'user_photo': '/api/v0.1/user/upload-photo',
  'user_header_image': '/api/v0.1/user/upload-header-image'
}
const friendlyImageFieldNames = {
  'user_photo': 'Profile photo',
  'user_header_image': 'Banner image'
}

// Action types

const HIDE_UPLOAD_MODAL = 'USER_SETTINGS_ACCOUNT_FORM_HIDE_UPLOAD_MODAL'
const SHOW_UPLOAD_MODAL = 'USER_SETTINGS_ACCOUNT_FORM_SHOW_UPLOAD_MODAL'
const SUBMIT = 'USER_SETTINGS_ACCOUNT_FORM_SUBMIT'
const UPDATE_FIELD = 'USER_SETTINGS_ACCOUNT_FORM_UPDATE_FIELD'
const UPLOAD = 'USER_SETTINGS_ACCOUNT_FORM_UPLOAD'

// Action dispatchers

function submit() {
  return function (dispatch, getState) {
    const { accountForm } = getState()
    if (accountForm.isSubmitting) {
      return // Submission is already in-progress
    }
    dispatch({
      type: SUBMIT,
      payload: { pending: true }
    })
    ajax({
      url: '/update-settings',
      method: 'post',
      data: { user: accountForm.fields.valuesObj() }
    })
    .then(response => {
      if (response.error) {
        dispatch({
          type: SUBMIT,
          payload: { error: true }
        })
        clientV1Bridge.showAlertModal({
          heading: 'Account update failed',
          subheading: response.message
        })
      } else {
        dispatch({
          type: SUBMIT,
          payload: { success: true }
        })
        dispatch(toastActions.showNotice({
          message: 'Account updated'
        }))
      }
    })
    .catch(err => {
      dispatch({
        type: SUBMIT,
        payload: { error: err }
      })
      let message = 'Sorry. We were not able to change your settings.'
      if (err instanceof FriendlyRequestError) {
        message = err.message
      } else {
        airbrake.notify(err)
      }
      clientV1Bridge.showAlertModal({
        heading: 'Account update failed',
        subheading: message
      })
    })
  }
}

function deleteImage({ name }) {
  const userModelKeysByFieldName = {
    'user_photo': 'photo_url',
    'user_header_image': 'header_image_url'
  }
  return function (dispatch) {
    const userModelKey = userModelKeysByFieldName[name]
    dispatch({
      type: UPLOAD,
      payload: { name, pending: true }
    })
    ajax({
      url: '/update-settings',
      method: 'post',
      data: { user: { [userModelKey]: '' } }
    })
    .then(response => {
      if (response.error) {
        dispatch({
          type: UPLOAD,
          payload: { name, error: true }
        })
      } else {
        dispatch({
          type: UPLOAD,
          payload: { name, success: true }
        })
        dispatch(updateField({ name, value: '' }))
        dispatch(toastActions.showNotice({
          message: `${friendlyImageFieldNames[name]} removed`
        }))
      }
    })
    .catch(err => {
      let message = 'Sorry. We were not able to delete that image.'
      if (err instanceof FriendlyRequestError) {
        message = err.message
      } else {
        airbrake.notify(err)
      }
      dispatch({
        type: UPLOAD,
        payload: { name, error: err }
      })
      clientV1Bridge.showAlertModal({
        heading: 'Image removal failed',
        subheading: message
      })
    })
  }
}

function uploadImage({ name, file }) {
  const url = urlsByImageFieldName[name]
  return function (dispatch, getState) {
    const { csrfToken } = getState().env
    uploader(url, name, file, { csrfToken, onProgress })
    .then(value => {
      dispatch({
        type: UPLOAD,
        payload: { name, success: true }
      })
      dispatch(updateField({ name, value }))
      dispatch(toastActions.showNotice({
        message: `${friendlyImageFieldNames[name]} updated`
      }))
    })
    .catch(err => {
      let message = 'Sorry. We were not able to upload that image.'
      if (err instanceof FriendlyRequestError) {
        message = err.message
      } else {
        airbrake.notify(err)
      }
      dispatch({
        type: UPLOAD,
        payload: { name, error: err }
      })
      clientV1Bridge.showAlertModal({
        heading: 'Image upload failed',
        subheading: message
      })
    })

    function onProgress(event, progress) {
      dispatch({
        type: UPLOAD,
        payload: { name, pending: true, progress }
      })
    }
  }
}

// Action creators

function showUploadModal(name, file) {
  return {
    type: SHOW_UPLOAD_MODAL,
    payload: { name, file }
  }
}

function hideUploadModal() {
  return {
    type: HIDE_UPLOAD_MODAL
  }
}

function updateField({ name, value }) {
  return {
    type: UPDATE_FIELD,
    payload: { name, value }
  }
}

// Action exports

module.exports = {
  HIDE_UPLOAD_MODAL,
  SHOW_UPLOAD_MODAL,
  SUBMIT,
  UPDATE_FIELD,
  UPLOAD,
  deleteImage,
  hideUploadModal,
  showUploadModal,
  submit,
  updateField,
  uploadImage
}
